import {Core} from './ThemeInterface';
import Typography from '../v2/style-helper/Typography';

export default (core: Core) => ({
  base: {
    fontFamily: core.typography.primary,
    color: core.foreground,
    // Values here are unassigned yet
    fontSize: 14,
    lineHeight: 1.4,
  },
  header: {
    url: '',
    backgroundColour: '#fff',
    logoHeight: 40,
    mobileLogoPlacement: 'center',
    padding: 16, // Maintain px as em breaks calculation for mobile
    marginTop: 10,
    mobileMargin: 16,
  },
  sectionHeader: {
    font: Typography.medium,
    fontSize: 18,
    fontFamily: core.typography.secondary,
    lineHeight: 1.2,
  },
  progressBar: {
    fontSize: 13,
    labelFont: Typography.extraSmall,
    colour: core.brand,
    counterPaddingTop: 0,
    counterPaddingLeft: 0,
    counterPaddingBottom: 0,
    counterSize: 20,
  },
  orderSummary: {
    titleFont: Typography.small,
    totalFont: Typography.medium,
    isBoldPrice: true,
    fontSize: 14,
    titleFontSize: 14,
    titleFontWeight: core.boldFontWeight,
    totalFontSize: 18,
    priceFontFamily: core.typography.primary,
    priceFontWeight: 400,
    mobileHeader: {
      summaryFontSize: 15,
      openSummaryFontSize: 13,
    },
    itemCountFontSize: 14,
  },
  deliveryOptions: {
    estimateFontWeight: core.boldFontWeight,
    priceFontWeight: core.boldFontWeight,
    priceFontFamily: core.typography.secondary,
    priceFontSize: 'inherit',
  },
  panel: {
    backgroundColour: core.brand,
    fontFamily: core.typography.secondary,
    fontWeight: core.boldFontWeight,
    letterSpacing: 'normal',
  },
  hasSurfaceHighlight: true,
  surfaceHighlight: core.brand,
  selectedFieldHighlight: core.brand,
  focusHighlightColour: core.brand,
  button: {
    fontSize: 16,
    fontFamily: core.typography.secondary,
    fontWeight: 400,
    lineHeight: 1,
    verticalPadding: '12px',
    borderWidth: 1,
    margin: 0,
    primary: {
      colour: core.background,
      backgroundColour: core.background,
      colourOnHover: core.background,
      backgroundColourOnHover: core.background,
    },
    secondary: {
      colour: core.background,
      backgroundColour: core.background,
      colourOnHover: core.background,
      backgroundColourOnHover: core.background,
    },
    link: {
      fontWeight: 400,
      colour: core.foreground,
    },
    large: {
      fontSize: 18,
      lineHeight: 1.8,
    },
    tab: {
      fontWeight: core.boldFontWeight,
      colour: core.brand,
    },
  },
  footer: {
    backgroundColour: '#f2f2f2',
  },
  completePage: {
    headerFont: Typography.extraLarge1,
    subheaderFont: Typography.medium,
    isBoldSubheader: true,
    infoHeaderFont: Typography.medium,
    isBoldInfoHeader: true,
    infoTitleFont: Typography.medium,
    infoSubHeaderFontWeight: 400,
    socialSharingStatisticBorderColour: '#000',
    referralCodeFontColor: '#333',
  },
  optionalDeliveryBasketItem: {
    backgroundColour: '#fff',
  },
});
